module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/shelby-800.f7271a60cea689ac.jpg"+" 800w",
        images: [{path: "https://static.sniffspot.com/packs/img/shelby-800.f7271a60cea689ac.jpg",width: 800,height: 490}],
        src: "https://static.sniffspot.com/packs/img/shelby-800.f7271a60cea689ac.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/shelby-800.f7271a60cea689ac.jpg"},
        
        width: 800,
        height: 490
      }